import { IWithChildren } from 'types';
import styles from './styles.module.scss';

export function Side({
  children,
}: { } & IWithChildren) {
  return (
    <aside className={styles.side}>
      {children}
    </aside>
  );
}
